import React, { useCallback } from 'react';
import { useMsal } from "@azure/msal-react";
import { getApiToken } from '../../../utils/authUtils.js';
import notify from 'devextreme/ui/notify';

import './FormPhoto.scss';
import { FileUploader } from 'devextreme-react';

export const FormPhoto = ({ link, size, editable, athleteId, onImageUploaded }) => {
  const { instance, accounts } = useMsal();

  const onValueChange = useCallback(async (e) => {
    if (!e[0] || !athleteId) return;

    try {
      const token = await getApiToken(instance, accounts);
      const formData = new FormData();
      formData.append('file', e[0]);
      formData.append('athleteId', athleteId);

      const response = await fetch(`${process.env.REACT_APP_serverEndpoint}/Athlete/UploadAthleteProfilePicture`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        },
        body: formData
      });

      const result = await response.json();

      if (result.success) {
        notify({
          message: 'Profilbild erfolgreich hochgeladen',
          position: { at: 'bottom center', my: 'bottom center' }
        }, 'success');
        
        // Neues Bild vom Server laden und als Blob-URL erstellen
        if (onImageUploaded) {
          try {
            const token = await getApiToken(instance, accounts);
            const imageResponse = await fetch(`${process.env.REACT_APP_serverEndpoint}/Athlete/GetAthleteProfilePicture?athlete_id=${athleteId}`, {
              headers: {
                'Authorization': `Bearer ${token}`
              }
            });
            
            if (imageResponse.ok) {
              const blob = await imageResponse.blob();
              const newImageUrl = URL.createObjectURL(blob);
              onImageUploaded(newImageUrl);
            }
          } catch (error) {
            console.error('Fehler beim Laden des neuen Bildes:', error);
          }
        }
      } else {
        notify({
          message: `Fehler beim Hochladen: ${result.userMessage || 'Unbekannter Fehler'}`,
          position: { at: 'bottom center', my: 'bottom center' }
        }, 'error');
      }
    } catch (error) {
      notify({
        message: `Fehler beim Hochladen des Profilbilds: ${error.message}`,
        position: { at: 'bottom center', my: 'bottom center' }
      }, 'error');
    }
  }, [instance, accounts, athleteId, onImageUploaded]);

  return (
    <div className='form-photo-view'>
      <div
        className={`form-photo ${editable ? 'editable' : ''}`}
        style={{
          width: size,
          height: size,
          maxHeight: size,
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {link && (
          <img
            src={link}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              display: 'block',
              position: 'absolute',
              top: 0,
              left: 0,
              borderRadius: '8px'
            }}
            onError={(e) => {
              console.error('Fehler beim Anzeigen des Bildes');
              e.target.style.display = 'none';
            }}
          />
        )}
        { editable && (
          <>
            {/* Dunkler Overlay beim Hover */}
            <div 
              className="edit-overlay"
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                borderRadius: '8px',
                opacity: 0,
                transition: 'opacity 400ms',
                zIndex: 5
              }}
            />
            {/* Edit Icon */}
            <i 
              className='edit-icon dx-icon-photooutline' 
              style={{ 
                position: 'absolute', 
                top: '50%', 
                left: '50%', 
                transform: 'translate(-50%, -50%)',
                zIndex: 10,
                fontSize: '28px',
                color: 'white',
                pointerEvents: 'auto',
                opacity: 0,
                transition: 'opacity 400ms'
              }} 
            />
          </>
        ) }
      </div>
      { editable &&
        <FileUploader
          dialogTrigger='.edit-icon'
          accept='image/*'
          visible={false}
          onValueChange={onValueChange}
          uploadMode='instantly'
        />
      }
    </div>
  );
};
